import { stryInit } from "./stry"

export function init() {
    stryInit()
}
